import { cn } from "@/lib/utils";

const TitleH4 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h4
      className={cn(
        "text-primary leading-[1.35] font-light tracking-normal text-[calc(18px*var(--h4-scale,var(--heading-scale,1)))] lg:text-[calc(19px*var(--h4-scale,var(--heading-scale,1)))] xl:text-[calc(22px*var(--h4-scale,var(--heading-scale,1)))] xl:leading-[1.3636]",
        className,
      )}
    >
      {title}
    </h4>
  );
};

export default TitleH4;
